class Notifications {
  display(message, status) {
    UIKit.notification({ message, status, pos: 'bottom-right', timeout: 5000 });
  }
}

export default Notifications;
